export { MONTHS_TO_ENTITLEMENT } from '../../utils/vacationEligibility';

export const STAGE_COPY = {
    tooEarly: {
        title: 'Ainda não é possível solicitar férias',
        body: (canRequestFrom: string) =>
            `Você poderá enviar sua solicitação a partir de 9 meses, em ${canRequestFrom}.`,
    },
    earlyRequest: {
        title: 'Você já pode solicitar suas férias',
        body: (entitledFrom: string) =>
            `O período aquisitivo termina em ${entitledFrom} — suas férias só podem começar a partir dessa data.`,
    },
} as const;
